import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Location } from '~src/commonInfra/utils/Location';
import { SiteRoles } from '~src/userManagement/users/serverApi/types/ISiteRole';

export namespace HomeUserUtils {

  /**
   * Some logic to account for weird behavior where Server Admins have a "Creator" role from getSessionInfo.
   */
  export function getRole(state: AppState): string {
    if (SessionUserSelectors.isSessionServerAdmin(state)) {
      return SiteRoles.ServerAdministrator;
    } else {
      return SessionSiteSelectors.siteRole(state);
    }
  }

  /**
   * Helper function used to determine whether to hide the welcome channel/banner.
   * Hide the banner when guided onboarding is enabled and if it's a trial site.
   */
  export function isGuidedOnboardingEnabled(siteTypeName: string): boolean {
    // It's not very convenient to create and maintain trial sites in different types of environments.
    // So in order to make the development and test easier, we allow to pass in guidedOnboardingDebug in URL parameter
    // to skip the check of the trial site then we can use any VPC sites (e.g. qa-near) for Guided Onboarding development and test. 
    return FeatureFlags.guidedOnboardingBannerEnabled &&
      (Location.instance.search().toLowerCase().indexOf('guidedonboardingdebug') !== -1 || siteTypeName === 'Trial');
  }
}
